import { render } from "./AlertDialog.vue?vue&type=template&id=7d18cdf4&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=7d18cdf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d18cdf4"]])

export default __exports__